export default function CTA() {
  const WHATSAPP_NUMBER = "919944940620"; // 🔴 replace with your WhatsApp number

  const openWhatsApp = () => {
    const message = `Hello Kaali Global Import & Export,

I would like to enquire about your premium Cardamom and Black Pepper products.
Please share product specifications, pricing, and supply details.

Thank you.`;

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <section id="contact" className="py-28 bg-[#f6f7f5]">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">

        {/* LEFT CONTENT */}
        <div>
          <p className="uppercase tracking-widest text-xs text-gray-500 mb-4">
            Let’s Work Together
          </p>

          <h2 className="text-4xl font-serif mb-6 leading-tight">
            Partner with a Trusted <br /> Indian Spice Supplier
          </h2>

          {/* Gold accent */}
          <div className="w-20 h-[2px] bg-[#c9a24d] mb-6"></div>

          <p className="text-gray-700 max-w-lg leading-relaxed">
            Kaali Global Import & Export supplies premium Cardamom and Black
            Pepper with consistent quality, flexible packaging, and reliable
            delivery for domestic and international markets.
          </p>
        </div>

        {/* RIGHT ACTION */}
        <div className="bg-white rounded-2xl p-10 shadow-md text-center">
          <h3 className="text-xl font-serif mb-4">
            Start Your Enquiry
          </h3>

          <p className="text-sm text-gray-600 mb-8">
            Reach out to us for product specifications, pricing, and supply
            details.
          </p>

          <button
            onClick={openWhatsApp}
            className="bg-[#0a7d4f] text-white px-12 py-4 text-sm uppercase tracking-wide rounded-full hover:bg-[#086a43] transition"
          >
            Contact Us
          </button>

          {/* subtle trust hint */}
          <p className="mt-4 text-[11px] text-gray-500">
            💬 Fast response via WhatsApp
          </p>
        </div>

      </div>
    </section>
  );
}
